import UIUtils from 'js/lib/UIUtils';

const getSamplePayloads = (params: {
  webhookUrl: any;
  sanitizedWebhookUrl: any;
  contentType?: any;
  batchMode?: any;
  sourceConfig?: any;
}) => {
  const {
    webhookUrl,
    sanitizedWebhookUrl,
    contentType = 'application/json',
    batchMode = false,
    sourceConfig,
  } = params;

  let data = `{
  "id": 1,
  "name":"one"
}`;

  if (contentType === 'application/xml') {
    data = `<root>
  <id>1</id>
  <name>one</name>
</root>`;
  } else if (batchMode === true) {
    data = `[
  {
    "id":1,
    "name":"one"
  },
  {
    "id":2,
    "name":"two"
  },
  {
    "id":3,
    "name":"three"
  }
]`;
  }

  return UIUtils.getWebhookSampleRequest(
    webhookUrl,
    sanitizedWebhookUrl,
    sourceConfig,
    contentType,
    data,
  );
};

export default getSamplePayloads;
